import React from 'react';

import '../styles/QbankButton.css';

function QbankButton(props) {
  return (
    <div style={{
      height: props.wrapperStyle ? props.wrapperStyle.height : props.style ? props.style.height : props.height,
      width: props.wrapperStyle ? props.wrapperStyle.width : props.style ? props.style.width : props.width,
      marginBottom: props.style ? props.style.marginBottom : undefined,
      margin: props.style ? props.style.margin : undefined,
    }}
      className={`qbank-button-wrapper ${props.wrapperClassName ? props.wrapperClassName : ''} `}>
      <div style={Object.assign({
        height: props.height,
        width: props.width,
      }, props.style ? props.style : {})}
        className={`${props.className ? `${props.className} ` : ''}${props.disabled ? 'disabled ' : ''}qbank-button`}
        onTouchTap={() => !props.disabled ? window.setTimeout(() => props.onClick(), 150) : null}
      >
        <p>{props.label}</p>
      </div>
    </div>
  );
}

export default QbankButton;

// QuestionCountProgress.propTypes = {
//   completed: React.PropTypes.bool.isRequired,
// };


// WEBPACK FOOTER //
// ./src/components/QbankButton.js